import { render, staticRenderFns } from "./RecursosListagem.vue?vue&type=template&id=0b3e542a&scoped=true"
import script from "./RecursosListagem.vue?vue&type=script&lang=js"
export * from "./RecursosListagem.vue?vue&type=script&lang=js"
import style0 from "./RecursosListagem.vue?vue&type=style&index=0&id=0b3e542a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3e542a",
  null
  
)

export default component.exports